import Vue from 'vue'
import router from '../../router'

export default {
  addAgency ({ commit }, data) {
    commit('ADD_NEW_AGENCY', data)
    router.push({ name: 'Office', params: { id: data.id } })
  },
  getAgency ({ commit }, id) {
    return Vue.axios.get(`/about/agencies/${id}`)
    .then(({ data }) => commit('ADD_AGENCY', data))
  },
  updateAgency ({ commit }, agency) {
    commit('UPDATE_AGENCY', agency)
  },
  updateAgencies ({ commit }, agencies) {
    commit('UPDATE_AGENCIES', agencies)
    return Vue.axios.put(`/about/agencies`, { agencies })
  },
  addConsultantPhoto ({ commit }, photoData) {
    commit('UPDATE_AGENCY_CONSULTANT_PHOTO', photoData)
  },
  deleteAgency ({ commit }, id) {
    return Vue.axios.delete(`/about/agencies/${id}`)
    .then(({ data }) => {
      commit('DELETE_AGENCY', id)
      router.push({ path: '/about/offices' })
    })
  },
  saveAgency ({ dispatch }, agency) {
    const consultants = agency.consultants
      .filter(s => s.photo && typeof s.photo === 'object')
    let newPhoto

    if (agency.photo && agency.photo.base64photo) {
      newPhoto = agency.photo.data
      delete agency.photo
    }

    return Vue.axios.put(`/about/agencies/${agency.id}`, { agency })
    .then(() => {
      if (newPhoto) {
        dispatch('loadAgencyPhoto', { formData: newPhoto, id: agency.id })
      }
    })
    .then(() => {
      return consultants.reduce(
        (p, v) => p.then((a) => dispatch('loadConsultantPhoto', { formData: v.photo.data, id: v.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
    })
  },
  loadAgencyPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/agencies/change-photo/${id}`, formData)
  },
  getAgencies ({ commit, dispatch }, id) {
    return Vue.axios.get('/about/agencies')
    .then(({ data }) => {
      commit('ADD_AGENCIES', data)
      if (!id && data[0]) {
        commit('ADD_AGENCY', data[0])
      }
    })
  },
  addConsultant ({ commit }, data) {
    commit('ADD_CONSULTANT', data)
  },
  deleteConsultant ({ commit }, id) {
    commit('DELETE_CONSULTANT', id)
  },
  updateConsultant ({ commit }, consultant) {
    commit('UPDATE_CONSULTANT', consultant)
  },
  loadConsultantPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/agencies/consultant/change-photo/${id}`, formData)
    .then(({ data }) => commit('CHANGE_CONSULTANT_PHOTO', data))
  },
  deleteConsultantPhoto ({ commit }, id) {
    commit('DELETE_CONSULTANT_PHOTO', id)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/about.js